export default __webpack_public_path__ + "static/media/16.8195cf5b.jpg";